export const checkEmpty = (value, str = '-') => {
  if (value) {
    return value;
  } else {
    return str;
  }
};

export const formatTel = (value) => {
  if (value) {
    return value.replace(/(.{3})(.{3})(.+)/, '$1-$2-$3');
  } else {
    return '-';
  }
};

export const formatBankAccount = (value) => {
  if (value) {
    return value.replace(/(.{3})(.{1})(.{5})(.+)/, '$1-$2-$3-$4');
  } else {
    return '-';
  }
};

export const formatCardId = (value) => {
  if (value) {
    return value.replace(/(.{1})(.{4})(.{5})(.{2})(.{1})/, '$1-$2-$3-$4-$5');
  } else {
    return '-';
  }
};